import styled from '@emotion/styled';
import { Box, Typography, Button } from '@mui/material';

const Main = styled(Box)``;

export default function RequiestStatusModal({
  requestStatus,
  handleClose,
  errorCollection,
}) {
  return (
    <Main
      display={'flex'}
      justifyContent={'center'}
      alignItems={'center'}
      flexDirection="column"
      mb={1}
    >
      <Box mb={3}>
        <Typography>{requestStatus}</Typography>
      </Box>
      <Box mb={3}>
        {errorCollection &&
          errorCollection?.map((err) => (
            <Typography textAlign={'center'}>
              {err?.message?.message} <br />
            </Typography>
          ))}
      </Box>
      <Button
        color="primary"
        variant="contained"
        fullWidth
        onClick={() => handleClose(false)}
      >
        {'Aceptar'}
      </Button>
    </Main>
  );
}
